import PropTypes from 'prop-types';
import React from 'react';

const WhyField = ({ add_why, id, isDisabled, name, onChange, value }) =>
  add_why ? (
    <textarea
      className="border-box w-100 h6"
      disabled={isDisabled}
      id={`"question_${id}_why"`}
      name={`questions[${name}-why]`}
      onChange={onChange}
      rows="6"
      value={value}
    />
  ) : null;

WhyField.propTypes = {
  add_why: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default WhyField;
